<question-wrapper [title]="title">
  @for (option of options; track option) {
  <div>
    <label class="ic-question-option__option">
      <input type="checkbox" [(ngModel)]="option.isChecked" class="ic-question-project-checkbox" (ngModelChange)="onValueChange()" />
      <span>{{ option.title }}</span>
    </label>
  </div>
  }
</question-wrapper>
